<template>
  <div>
    <v-subheader class="text-decoration-underline">Pendentes</v-subheader>
    <card-loading v-if="loadingActionPlans"></card-loading>
    <v-container fluid class="px-0" v-else>
      <div v-if="openedActionPlans.length">
        <action-plan-card
          :byMe="byMe"
          class="ma-2"
          v-for="(actionPlan, i) in openedActionPlans"
          :key="i"
          :oneActionPlan="actionPlan"
          @handleClicked="goToOneActionPlan($event)"
        ></action-plan-card>
      </div>
      <div v-else>
        <v-card-subtitle class="text-center">Nenhum item nesta lista.</v-card-subtitle>
      </div>
    </v-container>
    <v-divider></v-divider>
    <v-subheader>Terminados</v-subheader>
    <card-loading v-if="loadingActionPlans"></card-loading>
    <v-container fluid class="px-0" v-else>
      <div v-if="closedActionPlans.length">
        <action-plan-card
          :byMe="byMe"
          class="ma-2"
          v-for="(actionPlan, i) in closedActionPlans"
          :key="i"
          :oneActionPlan="actionPlan"
          @handleClicked="goToOneActionPlan($event)"
        ></action-plan-card>
      </div>
      <div v-else>
        <v-card-subtitle class="text-center">Nenhum item nesta lista.</v-card-subtitle>
      </div>
    </v-container>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from "vuex";

export default {
  props: {
    actionPlansList: {
      type: Array
    },
    byMe: {
      default: false,
      type: Boolean
    }
  },
  components: {
    CardLoading: () => import("@/components/shared/CardLoadingTransparent.vue"),
    ActionPlanCard: () => import("@/_action-plan/components/Card.vue")
  },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      allMyActionPlans: state => state.ActionPlan.allMyActionPlans,
      loadingActionPlans: state => state.ActionPlan.loadingActionPlans
    }),
    openedActionPlans() {
      if (this.actionPlansList.length) {
        return this.actionPlansList.filter(o => o.status === "opened");
      } else {
        return [];
      }
    },
    closedActionPlans() {
      if (this.actionPlansList.length) {
        return this.actionPlansList.filter(o => o.status === "closed");
      } else {
        return [];
      }
    }
  },
  methods: {
    goToOneActionPlan(id) {
      this.$router.push({ name: "OneActionPlan", params: { id: id } });
    }
  }
};
</script>